const CNPJ_FIRST_DV_WEIGHTS = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const CNPJ_SECOND_DV_WEIGHTS = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

const CNPJ_BLACKLIST = [
  '00000000000000',
  '11111111111111',
  '22222222222222',
  '33333333333333',
  '44444444444444',
  '55555555555555',
  '66666666666666',
  '77777777777777',
  '88888888888888',
  '99999999999999',
];

const invalidCPF = [
  '00000000000',
  '11111111111',
  '22222222222',
  '33333333333',
  '44444444444',
  '55555555555',
  '66666666666',
  '77777777777',
  '88888888888',
  '99999999999',
];

const charValueForCnpj = (char) => String(char).toUpperCase().charCodeAt(0) - 48;

const calcCnpjCheckDigit = (chars, weights) => {
  const sum = [...chars].reduce(
    (acc, char, index) => acc + charValueForCnpj(char) * weights[index],
    0,
  );
  const remainder = sum % 11;
  return remainder < 2 ? 0 : 11 - remainder;
};

export const normalizeTaxIdentifier = (value) => (
  (value || '').replace(/[^A-Za-z0-9]/g, '').toUpperCase()
);

export const isValidCnpj = (normalized) => {
  if (!normalized || normalized.length !== 14) {
    return false;
  }

  const upper = normalized.toUpperCase();

  if (!/^[0-9A-Z]{12}\d{2}$/.test(upper)) {
    return false;
  }

  if (CNPJ_BLACKLIST.includes(upper)) {
    return false;
  }

  const base = upper.slice(0, 12);
  const firstDigit = calcCnpjCheckDigit(base, CNPJ_FIRST_DV_WEIGHTS);
  const withFirstDigit = `${base}${firstDigit}`;
  const secondDigit = calcCnpjCheckDigit(withFirstDigit, CNPJ_SECOND_DV_WEIGHTS);
  const expected = `${withFirstDigit}${secondDigit}`;

  return upper === expected;
};

export const isValidCpf = (normalized) => {
  if (!normalized || normalized.length !== 11 || !/^\d{11}$/.test(normalized)) {
    return false;
  }

  if (invalidCPF.includes(normalized)) {
    return false;
  }

  const numberValue = normalized.slice(0, -2);
  const dv1 = normalized[9];
  const dv2 = normalized[10];

  return checkCpfDV(numberValue, dv1) && checkCpfDV(`${numberValue}${dv1}`, dv2);
};

export const isValidTaxIdentifier = (value, { allowCpf = true, allowCnpj = true } = {}) => {
  const normalized = normalizeTaxIdentifier(value);

  if (!normalized) {
    return false;
  }

  if (allowCpf && normalized.length === 11) {
    return isValidCpf(normalized);
  }

  if (allowCnpj && normalized.length === 14) {
    return isValidCnpj(normalized);
  }

  return false;
};

const checkCpfDV = (numberParam, dv) => {
  const check = numberParam
    .split('')
    .map((item, i) => item * (numberParam.length + 1 - i))
    .reduce((x, y) => x + y);

  let result = 11 - (check % 11);

  if (result === 10 || result === 11) {
    result = 0;
  }

  return result.toString() === dv;
};

export const isCpf = (cpf) => isValidCpf(normalizeTaxIdentifier(cpf));

export const isCNPJ = (cnpj) => isValidCnpj(normalizeTaxIdentifier(cnpj));
